import { render, staticRenderFns } from "./TutorialPromise.vue?vue&type=template&id=cf640e16&"
import script from "./TutorialPromise.vue?vue&type=script&lang=js&"
export * from "./TutorialPromise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports